module.exports = __webpack_public_path__ + "31b6e2a65b516845d19409e85e07b9f5.png";